(function () {
  'use strict';

  var el = document.querySelector('.article-meta__views');
  if (!el) return;

  var articleId = el.dataset.articleId;
  var key = 'article_views_' + articleId;
  var stored = localStorage.getItem(key);
  var count;

  if (!stored) {
    count = Math.floor(Math.random() * 201) + 100; // 100–300
  } else {
    count = parseInt(stored, 10) + 1;
  }

  localStorage.setItem(key, count);

  var countEl = el.querySelector('.article-meta__views-count');
  if (countEl) countEl.textContent = count;
})();
